'use client';

export { default } from './TableBody';
export { default as tableBodyClasses } from './tableBodyClasses';
export * from './tableBodyClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TableBody/index.js
// module id = 892
// module chunks = 22